import { Controller } from "@hotwired/stimulus"

/**
 * Sticky Header Controller
 * 
 * Adds a shadow effect when an element becomes "stuck" via CSS sticky positioning.
 * Uses IntersectionObserver for efficient detection.
 */
export default class extends Controller {
  static values = {
    offset: { type: Number, default: 60 } // Navbar height
  }

  connect() {
    this.setupObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.sentinel) {
      this.sentinel.remove()
    }
  }

  setupObserver() {
    // Create a sentinel element just above the sticky element
    // When it goes out of view, the element is "stuck"
    this.sentinel = document.createElement("div")
    this.sentinel.className = "sticky-sentinel"
    this.sentinel.style.cssText = "position: absolute; top: -1px; left: 0; right: 0; height: 1px; pointer-events: none;"
    
    // Insert sentinel before the sticky element
    this.element.style.position = "relative"
    this.element.insertBefore(this.sentinel, this.element.firstChild)

    // Create observer
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          // When sentinel is NOT intersecting, the header is stuck
          this.element.classList.toggle("is-stuck", !entry.isIntersecting)
        })
      },
      {
        threshold: 0,
        rootMargin: `-${this.offsetValue}px 0px 0px 0px`
      }
    )

    this.observer.observe(this.sentinel)
  }
}
